import type { CanvasNodeKind } from "./nodes/node-types.js";

export interface CanvasMenuPoint {
  x: number;
  y: number;
}

export type CanvasMenuState =
  | {
      kind: "blank";
      client: CanvasMenuPoint;
      flow: CanvasMenuPoint;
    }
  | {
      kind: "node";
      client: CanvasMenuPoint;
      flow: CanvasMenuPoint;
      nodeId: string;
    }
  | {
      kind: "edge";
      client: CanvasMenuPoint;
      flow: CanvasMenuPoint;
      edgeId: string;
    };

interface PointerLikeEvent {
  clientX: number;
  clientY: number;
}

interface FlowCoordinateConverter {
  screenToFlowPosition(point: CanvasMenuPoint): CanvasMenuPoint;
}

const quickAddKinds: readonly CanvasNodeKind[] = [
  "text",
  "image",
  "video",
  "audio",
  "script",
  "seedance"
];

function menuPoint(event: PointerLikeEvent): CanvasMenuPoint {
  return { x: event.clientX, y: event.clientY };
}

export function nodeKindsForQuickAdd(): CanvasNodeKind[] {
  return [...quickAddKinds];
}

export function openCanvasMenu(
  event: PointerLikeEvent,
  flowInstance: FlowCoordinateConverter
): CanvasMenuState {
  return openCanvasMenuAt(menuPoint(event), flowInstance);
}

export function openCanvasMenuAt(
  client: CanvasMenuPoint,
  flowInstance: FlowCoordinateConverter
): Extract<CanvasMenuState, { kind: "blank" }> {
  return { kind: "blank", client, flow: flowInstance.screenToFlowPosition(client) };
}

export function openNodeMenu(
  event: PointerLikeEvent,
  nodeId: string,
  flowInstance: FlowCoordinateConverter
): CanvasMenuState {
  const client = menuPoint(event);
  return { kind: "node", client, flow: flowInstance.screenToFlowPosition(client), nodeId };
}

export function openEdgeMenu(
  event: PointerLikeEvent,
  edgeId: string,
  flowInstance: FlowCoordinateConverter
): CanvasMenuState {
  const client = menuPoint(event);
  return { kind: "edge", client, flow: flowInstance.screenToFlowPosition(client), edgeId };
}
